import React, { Fragment, useState, useEffect, useRef } from "react";

import { apiData } from "../../../../actions";
// import { UsePlaceAuth } from "../../../../AppContext/AppContext";
// import DataLoader from "../../../../Utils/DataLoader";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";

function TourTravel() {
	let BtnMore = useRef(null);
	const place = useSelector(state => state.place);
	const [seeMoreModal, setSeeMoreModal] = useState(false);
	const [tourData, setTourData] = useState("");
	const [tourModal, setTourModal] = useState("");
	const [loader, setLoader] = useState(false);

	const handleSeeAllClick = async () => {
		setSeeMoreModal(true);		
		setTimeout(function () {
			document.getElementById("tourModal").innerHTML = "";
			let script = document?.createElement('script');
			script.src = tourModal?.split('"')[1];
			document.getElementById("tourModal")?.appendChild(script);
			
		}, 1000)
	};
	const GetTourTravelAll = async () => {
		setLoader(true);
		let payload = {
			city: place,
		};
		let apiRes = await apiData.ToursTravel(payload);
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setTourModal(apiRes?.data?.data);		
			setLoader(false);
		}
	};
	const GetTourTravel = async () => {
		setLoader(true);
		let payload = {
			city: place,
		};
		let apiRes = await apiData.toursTravelAll(payload);
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setTourData(apiRes?.data?.data);
			setLoader(false);
		}
	};
	useEffect(() => {
		//script for Tours and travel
		document.getElementById("ProductSlide").innerHTML = ""
		let script = document.createElement('script');
		script.src = tourData.split('"')[1]
		document.getElementById("ProductSlide").appendChild(script);
		
		GetTourTravel();
		
	}, [place,tourData]);
	
	useEffect(() => {
		//script for Tours and travel
		// document.getElementById("tourModal").innerHTML = ""
		// let script = document.createElement('script');
		// script.src = tourModal.split('"')[1]
		// document.getElementById("tourModal").appendChild(script);
		
		// GetTourTravel();
		GetTourTravelAll();
	}, [place]);
	
	return (
		<Fragment>
			<div className="flight-sec Things-sec">
				<div className="container">
					<div className="row">
						<div className="col-12 col-md-12 col-lg-12">
							<div data-aos="zoom-in-right" className="slider-sec">
								<h2>Tours & Travel</h2>
								<p>Enjoy the scenic views of National Parks</p>
							</div>
						</div>
						<div className="col-12 col-md-12 col-lg-12">
							{/* <div className="small-blog"> */}
							<div className="blog-main">
								<div data-aos="zoom-in-right" className="" id="ProductSlide">
								</div>
							</div>						
							<div className="view-tag clickable"></div>				
							<div className="view-tag clickable">
								<a id="" ref={BtnMore} onClick={handleSeeAllClick} className='m-4'>
									See All
								</a>
							</div>						
						</div>
					</div>
				</div>
			</div>
			<>
				<Modal
					show={seeMoreModal}
					onHide={() => setSeeMoreModal(false)}
					// backdrop="static"
					size="xl"
					className='modal_xl see-pop'
					keyboard={false}
				>
					<Modal.Header closeButton>
					</Modal.Header>
					<Modal.Body id="tourModal">
					</Modal.Body>
				</Modal>
			</>
		</Fragment>
	);
}
export default TourTravel;
